import ActiveUsersChart from './ActiveUsersChart';

export default ActiveUsersChart;
